<template>
     <SmallSquare content="消费者可同时拥有会员等级和权益卡；一个消费者可同时拥有多张权益卡" :padding='true' />
      <a-card :bordered="false">
          <a-button type="primary" v-has:memberCardAdd="()=>{$router.push('/assets/coupons/memberCard/card_add?type=add')}">新增权益卡</a-button>
          <a-form ref='form' :model='search' style="margin-top:30px;margin-bottom:30px;" :initialValues="search" :onFinish='onSearch' layout='inline'>
               <a-form-item label="权益卡" name='keywords'>
                  <a-input type="text" placeholder="请输入会员卡名称" style="width: 240px" v-model:value="search.keyword"></a-input>
              </a-form-item>
              <a-form-item label="创建时间" name='time'>
                   <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
              </a-form-item>
              <a-form-item label="已上架到云店" name='is_on_sale'>
                  <a-select v-model:value="search.is_on_sale" style="width: 120px" >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option :value="1">是</a-select-option>
                    <a-select-option :value="0">否</a-select-option>
                  </a-select>
              </a-form-item>
              <a-form-item label="核销方式" name='write_type'>
                  <a-select v-model:value="search.write_type" style="width: 120px" >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option :value="1">无指定门店核销</a-select-option>
                     <a-select-option :value="2">下单门店核销</a-select-option>
                  </a-select>
              </a-form-item>
               <a-form-item>
                 <a-button type="primary" htmlType='submit'>搜索</a-button>
               </a-form-item>
          </a-form>
           <a-table :loading='listLoading' :columns='columns' :data-source='list' rowKey='id'  bordered :pagination="pagination" @change="changePage">
               <template v-slot:action="{record}">
                    <a-dropdown>
                         <a class="ant-dropdown-link"> 操作
                           <DownOutlined />
                         </a>
                         <template v-slot:overlay>
                           <a-menu>
                             <a-menu-item>
                               <a v-has:memberCardEdit="()=>{$router.push('/assets/coupons/memberCard/card_edit?type=edit&id='+record.id)}" href="javascript:;">编辑</a>
                             </a-menu-item>
                             <a-menu-item>
                               <a v-has:memberCardDel="()=>{delMemberCard(record)}" href="javascript:;">删除</a>
                             </a-menu-item>
                           </a-menu>
                         </template>
                     </a-dropdown>
               </template>
           </a-table>
      </a-card>
</template>

<script>
  import { profit,profitDelete } from "@/api/assets";
import { DownOutlined, ExclamationCircleOutlined } from "@ant-design/icons-vue";
import { reactive, toRefs,ref,inject,createVNode, onMounted } from 'vue'
import { iscode } from '../../../../utils/app';
  import { message } from "ant-design-vue";
const form = {
    keyword:"",
    start_time:'',
    end_time:'',
    is_on_sale:'',
    write_type:'',
    page:1,
    limit:10
}

const columns = [
     {
            title: "卡ID",
            dataIndex: "id",
    },
     {
            title: "权益卡名称",
            dataIndex: "card_name",
    },
    {
            title: "有效期",
            dataIndex: "expiry_date",
             customRender:({record})=>{
                 return record.expiry_date?record.expiry_date + '月': '无'
            }
    },
     {
            title: "核销方式",
            dataIndex: "write_type",
    },
     {
            title: "已上架到云店",
            dataIndex: "is_on_sale",
            customRender:({record})=>{
                 return record.is_on_sale ? '是':'否'
            }
    },
    {
            title: "创建时间",
            dataIndex: "create_time",
    },
     {
            title: "操作",
            dataIndex: "action",
             slots: { customRender: "action" },
    },
]
export default{
    components:{DownOutlined},
   setup(){
     const $Modal = inject('$Modal')
       const search = ref(form)
       const state = reactive({
           listLoading:false,
            time:[],
             pagination:{ //分页
              total:0,
              current:1,
              pageSize:10,
               defaultPageSize:10,
               showSizeChanger:true, 
               pageSizeOptions:['5','10', '20', '30', '40', '50'], 
               showQuickJumper:true, 
               showTotal:(total)=> `共 ${total} 条`
             },
            list:[]
       })

       const methods ={
           onSearch(){
             search.value.page = 1;
             state.pagination.current = 1;
             methods.getProfit()
           },
           onChange(e){
               state.time = e;
               search.value.start_time = e[0];
               search.value.end_time = e[1];
           },
           delMemberCard(record){
                   $Modal.confirm({
                      centered: true,
                      width: 400,
                      title: '确定删除付费会员卡？',
                      icon: createVNode(ExclamationCircleOutlined),
                      content: '已领取会员卡的用户任何进行核销',
                      onOk:async()=> { 
                        console.log(record)
                        let res = await profitDelete({id:record.id}).then(res => res.data);
                        if (iscode(res,true)) {
                          setTimeout(()=>{
                            methods.getProfit()
                          },1000)
                        }
                      }
                    });
           },
           changePage(e){
              //  console.log(e)
               state.pagination.pageSize = e.pageSize;
               state.pagination.current = e.current;
               search.value.limit = e.pageSize;
               search.value.page = e.current;
               methods.getProfit()
           },
           async getProfit(){
            //  const hide = message.loading('正在加载中...', 0);
            state.listLoading = true;
             state.list = [];
             let result = await profit({...search.value}).then(res=>res.data)
             state.listLoading = false;
             if(iscode(result)){
                 console.log(result)
                 state.list = result.data.data || [];
                 state.pagination.total = result.data.total || 0;
             }else{
               message.error(result.msg)
             }
            //  setTimeout(hide);
           }
       }
       onMounted(()=>{
         methods.getProfit()
       })

       return {
           ...toRefs(state),
           search,
           ...methods,
           columns
       }
   }
}
</script>
